import React, { useState, useEffect } from 'react';
import logo from './axion-logo.png';

const Sidebar = ({ page, setPage }) => {
    const [hasActiveRun, setHasActiveRun] = useState(false);
    const [hasActiveCustom, setHasActiveCustom] = useState(false);

    useEffect(() => {
        const checkActive = () => {
            try {
                setHasActiveRun(Boolean(localStorage.getItem('microprod_active_run')));
                setHasActiveCustom(Boolean(localStorage.getItem('microprod_active_custom_production')));
            } catch (e) {
                // Ignore storage access errors
            }
        };

        checkActive();
        const interval = setInterval(checkActive, 1000);
        return () => clearInterval(interval);
    }, []);

    const navItems = [
        { id: 'products', label: 'Προϊόντα', icon: 'bi-box-seam', section: 'Βασικά Στοιχεία' },
        { id: 'ingredients', label: 'Συστατικά', icon: 'bi-pie-chart-fill', section: 'Βασικά Στοιχεία' },
        { id: 'recipies', label: 'Συνταγές', icon: 'bi-journal-bookmark-fill', section: 'Συνταγολόγιο' },
        { id: 'commands', label: 'Εντολές Παραγωγής', icon: 'bi-clipboard2-check-fill', section: 'Διαχείριση' },
        { id: 'execute', label: 'Εκτέλεση Συνταγής', icon: 'bi-play-circle-fill', section: 'Εκτέλεση', hasActive: hasActiveRun },
        { id: 'production', label: 'Custom Παραγωγή', icon: 'bi-gear-wide-connected', section: 'Εκτέλεση', hasActive: hasActiveCustom },
        { id: 'import', label: 'Εισαγωγή Δεδομένων', icon: 'bi-database-fill-up', section: 'Εργαλεία' },
    ];

    let currentSection = '';

    return (
        <aside className="ek-sidebar">
            <a href="https://axionsoft.gr" target="_blank" rel="noopener noreferrer" className="ek-sidebar-brand">
                <img src={logo} alt="Axion Logo" className="ek-sidebar-logo" />
                <div className="ek-sidebar-brand-text">
                    <h1>MicroProduction+</h1>
                    <span>Axion MES / MRP</span>
                </div>
            </a>

            <nav className="ek-sidebar-nav">
                {navItems.map((item) => {
                    const showSectionHeader = item.section !== currentSection;
                    if (showSectionHeader) {
                        currentSection = item.section;
                    }

                    return (
                        <React.Fragment key={item.id}>
                            {showSectionHeader && (
                                <div className="ek-nav-section-title">{item.section}</div>
                            )}
                            <button
                                type="button"
                                className={`ek-sidebar-item ${page === item.id ? 'active' : ''}`}
                                onClick={() => setPage(item.id)}
                            >
                                <i className={`bi ${item.icon}`}></i>
                                <span className="flex-grow-1">{item.label}</span>
                                {item.hasActive && (
                                    <span className="badge rounded-pill bg-warning text-dark" style={{ fontSize: '0.65rem' }}>
                                        Σε εξέλιξη
                                    </span>
                                )}
                            </button>
                        </React.Fragment>
                    );
                })}
            </nav>

            <div className="ek-sidebar-footer">
                <div className="ek-system-status">
                    <span className="ek-status-dot"></span>
                    <div className="flex-grow-1">
                        <div style={{ fontWeight: 600, color: '#ffffff' }}>Σύστημα Ενεργό</div>
                        <div style={{ fontSize: '0.72rem', color: '#94a3b8' }}>Axion Software Solutions</div>
                    </div>
                </div>
            </div>
        </aside>
    );
};

export { Sidebar };
export default Sidebar;
